<template>
  <div v-click-away="onClosePallete" class="gf_color-palette">
    <div class="gf_color-palette--header">
      <div class="gf_color-palette--header-title">Color Styles</div>
      <div class="gf_color-palette--header-close" @click="onClosePallete">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.35355 1.64645C2.15829 1.45118 1.84171 1.45118 1.64645 1.64645C1.45118 1.84171 1.45118 2.15829 1.64645 2.35355L7.29289 8L1.64645 13.6464C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L8 8.70711L13.6464 14.3536C13.8417 14.5488 14.1583 14.5488 14.3536 14.3536C14.5488 14.1583 14.5488 13.8417 14.3536 13.6464L8.70711 8L14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L8 7.29289L2.35355 1.64645Z"
            fill="white" />
        </svg>
      </div>
    </div>
    <div class="colors">
      <Teleport to="#tooltips">
        <Tooltip :top="-4" :pointer="true" :width="'auto'" class="text-center" />
      </Teleport>
      <template v-for="(value, name) in filteredColors" :key="name">
        <ColorItem
          v-tooltip.top="COLOR_KEYS_MAP_STYLE_NAME[name]"
          :is-active="color.includes(COLOR_KEYS_MAP[name])"
          :is-can-change-color="false"
          :color="value"
          @click="pickColor({ name, value })" />
      </template>
    </div>
    <div class="gf_color-palette--footer" @click="onEditColorStyle">Edit styles</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { COLOR_KEYS_MAP, COLOR_KEYS_MAP_STYLE_NAME, COLOR_KEYS_MAP_ORDERED } from '@/constants/global-style';
import ColorItem from '@/core/components/base/color/ColorItem.vue';

export default defineComponent({
  name: 'GfColorPalette',
  components: {
    ColorItem,
  },
  props: {
    color: {
      type: String,
      default: '',
    },
  },
  data: (): any => ({
    colors: Object({}),
    COLOR_KEYS_MAP,
    COLOR_KEYS_MAP_STYLE_NAME,
  }),
  computed: {
    ...mapState('sidebar', {
      currentPreset: (state) => (state as any).currentPreset,
    }),
    filteredColors() {
      return Object.fromEntries(Object.entries(this.colors).filter(([key, value]) => value));
    },
  },
  created() {
    const colorsValue = this.currentPreset.presetOptions?.colors[0]?.value;

    for (const colorType in colorsValue) {
      for (const color in Object(colorsValue)[colorType]) {
        const className = `${colorType}-${color}`;
        if (colorsValue[colorType][color]) {
          this.colors[className] = colorsValue[colorType][color];
        }
      }
    }
    this.colors = { ...COLOR_KEYS_MAP_ORDERED, ...this.colors };
  },
  methods: {
    pickColor(color: object) {
      this.$emit('pickColor', color);
    },
    onEditColorStyle() {
      this.$emit('editColorStyle');
    },
    onClosePallete() {
      this.$emit('onClosePallete');
    },
    getItemColorStyle(color: any) {
      return {
        background: color,
        border: `1px solid ${
          this.$tinycolor(color).isDark()
            ? this.$tinycolor.mix(color, 'white', 30).toHex8String()
            : this.$tinycolor.mix(color, 'black', 30).toHex8String()
        }`,
      };
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gf_color-palette {
  background: map-get($hybrid-shade-dark, '200');
  box-shadow: 0 2px 32px rgba(0, 0, 0, 0.16), 0 6px 6px rgba(0, 0, 0, 0.06);
  border-radius: $radius;
  padding: 8px;
  width: 240px;

  .colors {
    margin: 0 4px 4px;
    display: flex;
    flex-wrap: wrap;

    :deep(.wrapper) {
      margin: 1px;
    }
  }

  &--header {
    display: flex;
    justify-content: space-between;
    height: 32px;
    padding: 0 8px;

    &-title {
      color: map-get($hybrid-shade-light, '500');
    }

    &-close {
      cursor: pointer;
    }
  }

  &--footer {
    margin-bottom: 8px;
    padding-top: 8px;
    text-align: center;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    color: map-get($primary-blue, '250');
    cursor: pointer;
  }
}
</style>
